import styled, { css } from 'styled-components'

import FICColors from '../../common/FICColors'

export const BreadCrumbsImp = styled.div<{
  shadow: boolean
  embedded: boolean
}>`
  height: 64px;
  width: 100%;
  box-sizing: border-box;
  background-color: ${FICColors.white};
  border-bottom: 1px solid rgba(51, 51, 51, 0.08);
  position: relative;
  color: ${FICColors.textDefault};
  font-size: 16px;
  z-index: 100;
  @media (max-width: 425px) {
    font-size: 14px;
  }
  ${(props) =>
    props.shadow &&
    css`
      transition: box-shadow 0.3s ease-in-out;
      box-shadow: 0 9px 16px 0 rgba(0, 0, 0, 0.1);
    `}
  .breadCrumbsContainer {
    max-width: 940px;
    margin: 0 auto;
    position: relative;
    ${(props) =>
      props.embedded &&
      css`
        max-width: 800px;
      `}
  }
  .breadContainer {
    max-width: 940px;
    margin: 0 auto;
    position: relative;
  }
  .embeddedbreadCrumbs {
    max-width: 800px;
  }
  .svg-inline--fa {
    margin: 0 8px;
    color: ${FICColors.textDefault};
    font-size: 14px;
  }
  .internalAutocomplete {
    float: right;
    width: 50px;
    margin: 0;
    max-height: 100%;
    box-sizing: border-box;
    box-shadow: none;
    .svg-inline--fa {
      font-size: 24px;
      color: #333;
      z-index: 10000;
    }
    input {
      height: 100%;
    }
  }
`
export const BreadCrumbsText = styled.div`
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  @media (max-width: 425px) {
    width: calc(100% - 50px);
  }
  a {
    text-decoration: underline !important;
  }
`
